/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StorageNodeMini,
    StorageNodeMiniFromJSON,
    StorageNodeMiniFromJSONTyped,
    StorageNodeMiniToJSON,
    VolumeMini,
    VolumeMiniFromJSON,
    VolumeMiniFromJSONTyped,
    VolumeMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface Queue
 */
export interface Queue {
    /**
     * 
     * @type {string}
     * @memberof Queue
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof Queue
     */
    readonly group: string;
    /**
     * 
     * @type {string}
     * @memberof Queue
     */
    readonly priority: string;
    /**
     * 
     * @type {boolean}
     * @memberof Queue
     */
    inputBased: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Queue
     */
    readonly isServiced: boolean | null;
    /**
     * 
     * @type {StorageNodeMini}
     * @memberof Queue
     */
    node?: StorageNodeMini | null;
    /**
     * 
     * @type {VolumeMini}
     * @memberof Queue
     */
    volume?: VolumeMini;
}

export function QueueFromJSON(json: any): Queue {
    return QueueFromJSONTyped(json, false);
}

export function QueueFromJSONTyped(json: any, ignoreDiscriminator: boolean): Queue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'group': json['group'],
        'priority': json['priority'],
        'inputBased': json['input_based'],
        'isServiced': json['is_serviced'],
        'node': !exists(json, 'node') ? undefined : StorageNodeMiniFromJSON(json['node']),
        'volume': !exists(json, 'volume') ? undefined : VolumeMiniFromJSON(json['volume']),
    };
}

export function QueueToJSON(value?: Queue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'input_based': value.inputBased,
        'node': StorageNodeMiniToJSON(value.node),
        'volume': VolumeMiniToJSON(value.volume),
    };
}


